module.exports = __webpack_public_path__ + "static/media/buildingBackground.fe87cf0f.png";